// Group starts with underscore
const setCheckedLayerKey = entry => `_${entry.index}-${entry.name}`;

export default setCheckedLayerKey;
